import { render, staticRenderFns } from "./greenProductList.vue?vue&type=template&id=526b67d3&scoped=true"
import script from "./greenProductList.vue?vue&type=script&lang=js"
export * from "./greenProductList.vue?vue&type=script&lang=js"
import style0 from "./greenProductList.vue?vue&type=style&index=0&id=526b67d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b67d3",
  null
  
)

export default component.exports